import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import SnResizeBar from "@shared/components/SnResizeBar";

interface Props {
  Menuprops: menuInfo;
}

const LINK_COLUMNS = ["cd_item"]; // 메뉴 메인컬럼 ex) 수주등록 no_so, 발주등록 no_po

const SN_MTL_EVL_REP_008 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
    grid1: React.createRef<SnGridRef>(),
    grid2: React.createRef<SnGridRef>(),
  });

  const getGridCurrent = (key: string): SnGridRef => {
    const grid = gridRefs.current[key]?.current;
    if (!grid) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return grid;
  };

  const searchRef = useRef<any>(null);

  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding

  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
  });

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        // 초기값에 공유로 받은 값이 있으면 덮어쓰지 않고 유지
        setFormData((prev: any) => ({
          ...(rtn.formData || {}),
          ...(prev || {}),
        }));

        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  //#region onSearch
  const onSearch = async (searchData: any) => {
    try {
      const searchDataToUse = searchData || searchRef.current.getFormdata();
      searchDataToUse.dt_from = searchDataToUse.dt_from.slice(0, 6);
      searchDataToUse.dt_to = searchDataToUse.dt_to.slice(0, 6);

      const params = {
        id: "sn_mtl_evl_rep_008_01",
        params: searchDataToUse,
      };

      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0],
        grid2: data[1],
      });
    } catch (error: any) {}
  };
  //#endregion

  //#region useMemo
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
      },
    }),
    [columns, dataSources]
  );
  //#endregion

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              rowSelection: "single",
              title: "",
            }}
            filter={{
              refs: [gridRefs.current["grid2"]],
              columns: LINK_COLUMNS,
            }}
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid2"]}
            columnConfig={grids.grid2.columns}
            rowData={grids.grid2.dataSource}
            etcProps={{
              rowSelection: "single",
              title: "",
            }}
          />
        </SnResizeBar>
      </div>
    </div>
  );
});

export default SN_MTL_EVL_REP_008;
